import { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../component/CustomDropdown";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import FileUpload from "../../component/SvgIcons/FileUpload";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import "./style.css";
import IconKey from "../../component/SvgIcons/IconKey";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import IconClose from "../../component/SvgIcons/IconClose";
import utils, { emailPattern, phonePattern } from "../../utils/utils";
import IconError from "../../component/SvgIcons/IconError";
import { InputText } from "primereact/inputtext";

const agentcompanydata = [
  { value: "", label: "Select Company", disabled: true },
  { value: "Global Assist", label: "Global Assist", disabled: true },
  { value: "Field Assist", label: "Field Assist" },
  { value: "Gulf Konnect", label: "Gulf Konnect" },
  { value: "Gulf Oil", label: "Gulf Oil" },
  { value: "Global Gulf Support", label: "Global Gulf Support" },
   { value: "Global Software", label: "Global Software" },
  
];
const createAgent = {
  name: "",
  email: "",
  password: "",
  phonenumber: "",
  usertype: "",
  agentcompany: "",
  Extensions_Number: "",
  userrights: [],
  picture: null,
};

export default function CreateAgents() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [formData, setFormData] = useState({ ...createAgent });
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const fileInputRef = useRef(null);
  const { alert } = useSwal();  

  useEffect(()=>{
    utils.saveRecentSearch('Create Agent' , '/create-agents')
  })  
const getFieldError = (name, value) => {
  switch (name) {
    case "name":
      return !value?.trim() ? "Name is required." : "";
    case "email":
      if (!value?.trim()) return "Email is required.";
      return emailPattern(value.trim()) ? "" : "Invalid email address.";
    case "password":
      if (!value) return "Password is required.";
      return value.length < 6 ? "Password must be at least 6 characters." : "";
    case "phonenumber":
      if (!value?.trim()) return "Phone number is required.";
      return phonePattern(value.trim()) ? "" : "Invalid phone number.";
    case "agentcompany":
      return !value ? "Agent company is required." : "";
    default:
      return "";
  }
};

   const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };
  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

const handleFileChange = (e) => {
  const file = e.target.files[0];
  setSelectedFile(file);
  setFormData({ ...formData, picture: file });
  
  if (file) {
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  } else {
    setImagePreview("");
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();
 const requiredFields = ["name", "email", "password", "phonenumber", "agentcompany"];

  let newErrors = {};
  let isValid = true;

  requiredFields.forEach((field) => {
    const error = getFieldError(field, formData[field]);
    if (error) {
      isValid = false;
      newErrors[field] = error;
    }
  });

  setFormErrors(newErrors);

  if (!isValid) {
    await alert("warning", "Please fill in all required fields correctly.");
    return;
  }

  const formDataagent = new FormData();
  formDataagent.append("Agent_Name", formData.name);
  formDataagent.append("Email_Id", formData.email);
  formDataagent.append("Password", formData.password);
  formDataagent.append("Phone_No", formData.phonenumber);
  formDataagent.append("Status", "Active");
  formDataagent.append("User_Type", "Agent");
  formDataagent.append("Agents_Company", formData.agentcompany);
  formDataagent.append("Extensions_Number", formData.Extensions_Number);
  formDataagent.append("isAdmin", "No");
  formDataagent.append("User_Rights", JSON.stringify(formData.userrights));
  
  // Append file only once
  if (formData.picture) {
    formDataagent.append("Images", formData.picture);
  }

  try {
    setLoading(true);
    const res = await api.post("/create_agent", formDataagent, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    await alert("success", res.data.message || "Agent created successfully");
      setFormData({ ...createAgent });
      setSelectedFile(null);
      setImagePreview("");
      if (fileInputRef.current) fileInputRef.current.value = null;
      setResetKey((prevKey) => prevKey + 1);
  } catch (err) {
    setLoading(false);
    console.error("API error response:", err.response || err);
    const message = err.response?.data?.message || "Something went wrong.";
    await alert("error", message);
  } finally {
    setLoading(false);
  }
};



  const handleReset = () => {
    setFormData({ ...createAgent });
    // Also reset the file input reference
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setResetKey((prevKey) => prevKey + 1);
  };

  return (
    <div className="dashboard">
      <Header title subtitle="Create Agent" searchbar backbtn="/manage-agents" />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span>Create Agent</span>
            </h2>            
            <AnimatePresence mode="wait">
              <motion.form
                key={resetKey}  // unique key to trigger animation if needed
                className="myform d-flex flex-column justify-content-between"
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="create-form d-flex flex-column">
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className={`form-group ${formErrors.name ? "fieldrequire" : ""}`}>
                      <label>Name <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter Name"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                       <small className="hide"><IconError/></small>   
                    </div>
                    <div className={`form-group ${formErrors.email ? "fieldrequire" : ""}`}>
                      <label>E-Mail ID  <span className="required-asterisk">*</span></label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter E-Mail ID"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                       <small className="hide"><IconError/></small>
                    </div>
                    <div className={`form-group ${formErrors.password ? "fieldrequire" : ""}`}>
                      <label>Password <span className="required-asterisk">*</span> <Link className="hereshowpassword tranparenteffect" onClick={() => setShowPassword(!showPassword)}>
                        <IconKey />
                      </Link>
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="form-control"
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                       <small className="hide" style={{right:"45px"}}><IconError/></small>
                    </div>
                  </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                   <div className={`form-group ${formErrors.phonenumber ? "fieldrequire" : ""}`}>
                      <label>Phone Number  <span className="required-asterisk">*</span></label>
                       <InputText keyfilter="int" name="phonenumber" value={formData.phonenumber}
                        className="form-control" onChange={handleInputChange}  placeholder="Enter Phone Number" />
                      {/* <input
                        type="text"
                        name="phonenumber"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        value={formData.phonenumber}
                        onChange={handleInputChange} 
                        inputMode="numeric"
                        onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " "];
                          const allowedChars = /^[\d+\-\s]$/;                            
                          if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
                            return;
                          }                            
                          if (!allowedChars.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}                         
                      /> */}
                      <small className="hide"><IconError/></small>
                    </div>
                    <div className="form-group">
                      <label>Agent Type</label>               
                       <input
                        type="Text"
                        name="usertypes"
                        className="form-control"
                        placeholder="Agent"
                        value={formData.usertype}
                        onChange={handleInputChange}
                       readOnly
                      />
                    </div>
                    <div className={`form-group ${formErrors.agentcompany ? "fieldrequire" : ""}`}>
                      <label>Agents Company  <span className="required-asterisk">*</span></label>
                      <CustomDropdown
                        options={agentcompanydata}
                        placeholder="Select Agents Company"
                        name="agentcompanydata"
                        value={formData.agentcompany}
                        onChange={(val) => handleDropdownChange("agentcompany", val)}
                      // className="custom-dropdown"
                      />
                       <small className="hide" style={{right:"40px"}}><IconError/></small>
                    </div>
                  </div>

      <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">         


          <div className={`form-group`}>
                      <label>Extensions number  </label>
                      <InputText keyfilter="int" name="Extensions_Number" value={formData.Extensions_Number}
                        className="form-control" onChange={handleInputChange}  placeholder="Enter extensions number" />
                      {/* <input
                        type="text"
                        name="Extensions_Number"
                        className="form-control"
                        placeholder="Enter extensions number"
                        value={formData.Extensions_Number}
                        onChange={handleInputChange} 
                        // maxLength={10}
                        inputMode="numeric"
                        keyfilter="int"                     
                      /> */}
                      <small className="hide"><IconError/></small>
                    </div>

                  <div className="form-group d-flex justify-content-center gap-3 flex-column flex-md-row">


  


                    
                    <div className="pictureupload">
                               <input
                                ref={fileInputRef}
                                type="file"                                
                                name="Images"
                                accept=".jpg, .jpeg, .png, .webp"
                                className="custom-file-input position-absolute visually-hidden z-index-1"
                                id="inputGroupFile01"
                                onChange={handleFileChange}
                              />

                              <label
                                className="custom-file-label d-flex align-items-center justify-content-center"
                                htmlFor="inputGroupFile01"
                                style={{color:"#fff"}}
                              >
                                <FileUpload /> Upload Agent Picture
                              </label>
                            </div>
                 
                                  <AnimatePresence>
                            {(selectedFile || imagePreview) && (
                              <motion.div
                                className="selected-file d-flex align-items-center justify-content-center gap-2"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.3 }}
                              >
                                <a
                                  href={imagePreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mb-0 text-decoration-underline text-primary"
                                  style={{
                                    cursor: "pointer",
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                  title={selectedFile ? selectedFile.name : ""}
                                >
                                  {selectedFile
                                    ? selectedFile.name.length > 25
                                      ? `${selectedFile.name.slice(0, 25)}...`
                                      : selectedFile.name
                                    : ""}
                                </a>
                                <button
                                  type="button"
                                  className="btn p-0"
                                  onClick={() => {
                                    setSelectedFile(null);
                                    setFormData({ ...formData, picture: null });
                                    setImagePreview("");
                                    if (fileInputRef.current) fileInputRef.current.value = "";
                                  }}
                                >
                                  <IconClose/>
                                </button>
                              </motion.div>
                            )}
                          </AnimatePresence>

                  </div></div>   
      
                </div>
                <div className="form-savebtns d-flex justify-content-end flex-row align-items-center">
                  <button
                    type="button"
                    className="btn cancelbtn"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                  <button type="submit" className="btn btngradiant" disabled={loading}>
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </motion.form>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}